import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { GA_ENABLED } from './ga';

/**
 * Tracks page views with Google Analytics on route changes.
 * No-ops until a real GA4 measurement ID is configured in src/index.js.
 */
const useGaPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ENABLED) return;
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
      title: document.title || 'Cosmik Drones',
    });
  }, [location]);
};

export default useGaPageTracker;
